// extracted by mini-css-extract-plugin
export default {"tags":"CategoryFilterTag_tags__3hvld","tag":"CategoryFilterTag_tag__fSUGm","removeBtn":"CategoryFilterTag_removeBtn__fhtTA"};